import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TTukekaeZissekiListByNendoGetReq,
  TTukekaeZissekiListGetReq,
  TTukekaeZissekiListGetRes,
} from "./TTukekaeZissekiList"

/**
 * 付替実績一覧に対するAPIリクエスト用サービス
 *
 * @export
 * @class TukekaeZissekiListService
 * @extends {ConnectApi}
 */
export default class TukekaeZissekiListService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TTukekaeZissekiListGetReq} params
   * @memberof SyaryoKeihiService
   */
  getList = async (params: TTukekaeZissekiListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTukekaeZissekiListGetRes>> =
        await this.getInner(`budget/tukekaezisseki/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 検索取得(年度)
   *
   * @param {TTukekaeZissekiListGetReq} params
   * @memberof SyaryoKeihiService
   */
  getListBy年度 = async (params: TTukekaeZissekiListByNendoGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTukekaeZissekiListGetRes>> =
        await this.getInner(`budget/tukekaezisseki/list/year`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
